import Nav from './components/Nav';
import Services from './components/Services';
import './main.scss';

function docReady(fn: () => void) {
  // see if DOM is already available
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
      // call on next available tick
      setTimeout(fn, 1);
  } else {
      document.addEventListener('DOMContentLoaded', fn);
  }
} 

docReady(() => {
  const nav = new Nav({
    selector: '.top-navigation',
  });

  const services = new Services({
    selector: '.gb-services-wrap',
  });
});
